import { types } from 'mobx-state-tree';


const INQUIRY_TYPES = {
    CPC_CLICK: 'CPC_CLICK',
    CPA_CLICK: 'CPA_CLICK',
    SUBMITTED_LEAD: 'SUBMITTED_LEAD',
};

const InquiryTypeEnum = types.enumeration('InquiryType', Object.values(INQUIRY_TYPES));

export {
    InquiryTypeEnum,
};
export default INQUIRY_TYPES;
